
<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Short Scan</h2>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row justify-content-md-center upload">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>Short Scan</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- Chart -->
              <div class="chart">
                <span class="round"><img src="@/assets/img/vector/upload-csv01.png" alt /></span>
                <h4>
                  <i class="fa fa-arrow-circle-right" aria-hidden="true"></i> INFORMATION
                </h4>
                <p>Retrieve the short positions from the imported file</p>
                <br />
                <br />
                <label for="file-upload" class="custom-file-upload btn btn-primary my-2">
                  Select text file
                  <i v-if="!loading" class="fas fa-cloud-upload-alt"></i>
                  <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </label>
                <input id="file-upload" type="file" accept=".txt"  @change="upload('input')" />
                <div v-if="error" class="alert alert-danger" role="alert">
                  <i class="fas fa-exclamation-triangle"></i>
                  File upload failed. Please try again
                </div>
                <div v-if="success" class="alert alert-success" role="alert">
                  <i class="fas fa-check-circle"></i>
                  File has been downloaded.<br>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
    </div>
  </div>
</template>
<script>
    import authService from "@/authService";
    import AWS from 'aws-sdk/global';
    import config from "@/config";
    export default {
        name: 'tmcCSVtopdf',
        components :{
            
        },
        data() {
            return {
                loading : false,
                error : null,
                errors: [],
                success : false,
                uploadPercentage: 0,
                
            };
        },
        methods: {
          tmcFileUpload(filePath){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            let data  =  {
            //   "userId" : authService.getUser().id,
              "key": filePath,
              "cognitoSub" : authService.getUser().cognitoSub,
            }
            this.$http
            .post(
              config.baseUrlAutoBidder +
                "/excel/shortscan-upload",
               data,
               auth
            )
            .then((result) => {
              this.loading = false;
              this.error = false;
              this.success = true;
              window.open(result.data, "_blank");
              data
            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
                this.error = true;
                this.success = false;
              });
          },
          upload: function(albumName) {
              this.error = false;
              this.success = false;
              var s3 = new AWS.S3({
                apiVersion: "2006-03-01",
                params: { Bucket: "imsfileupload"}
              });
              console.log(s3);
              var files = document.getElementById("file-upload").files;
              if (!files.length) {
                return alert("Please choose a file to upload first.");
              }
              var file = files[0];
              var fileName = file.name;
              var albumPhotosKey = encodeURIComponent(albumName) + "/";
              var UUID = this.uuidv4();
              console.log(UUID);
              var photoKey = albumPhotosKey + fileName;
              var albumBucketName = config.albumBucketNameIms+"/shortscanupload/"+UUID;
              console.log(photoKey);
              this.loading = true;
              // Use S3 ManagedUpload class as it supports multipart uploads
              var self = this;
              s3.upload(
                { Key: file.name, Bucket: albumBucketName, Body: file, ACL: "private" },
                function(err, data) {
                  this.fileuploading = false;
                  if (err) {
                    console.log(err, "there was an error uploading your file");
                  } else {
                    this.locationUrl = data.Location;
                    this.serviceBucketName = data.Bucket;
                    this.s3response = data;
                    document.getElementById("file-upload").value=null; 
                    self.tmcFileUpload("shortscanupload/"+UUID+"/"+file.name)
                  }
                }
              );
          }
        },
        created: function() {
          this.user = this.$cognitoAuth.getCurrentUser();
          this.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
              console.log("accessToken is not found", err);
            } else {
              this.accessToken = result;
            }
          });
          const userPoolLoginKey = config.userPoolLoginKey;
          const logins = {};
          logins[userPoolLoginKey] = this.accessToken;
          AWS.config.region = config.region;
          const cognitoParams = {
            IdentityPoolId: config.IdentityPoolIdFileUpload,
            Logins: logins
          };
          let cognitoidentity = new AWS.CognitoIdentity();
          cognitoidentity.getId(cognitoParams, function(err, data) {
            if (err) {
              console.log(err);
            } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
                region: bucketRegion,
                credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
            }
          });
        }
    };
  </script> 